// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_eG","advertDetailContactItem__link":"c-n_eH"};